<template>
  <q-page class="container" padding>
    <PageHeader
      title="Cadastrar Modulo"
      :backRoute="{ name: 'home' }"
      backBehavior="route"
    />

    <q-card>
      <q-card-section>
        <q-form ref="myForm">
          <div class="row col-12 q-col-gutter-sm">
            <div class="col-md-3 col-sm-12 col-xs-12">
              ModuloID:
              <q-input
                dense
                outlined
                label="ModuloID"
                v-model="idModulo"
                :rules="[
                  (val) => (val && val.length > 0) || 'Campo Obrigatório',
                ]"
              >
                <template v-slot:prepend>
                  <q-icon name="person" />
                </template>
              </q-input>
            </div>

            <div class="col-md-3 col-sm-12 col-xs-12">
              Nome do Modulo:
              <q-input
                dense
                outlined
                label="Modulo Nome"
                v-model="nomeModulo"
                :rules="[
                  (val) => (val && val.length > 0) || 'Campo Obrigatório',
                ]"
              >
                <template v-slot:prepend>
                  <q-icon name="person" />
                </template>
              </q-input>
            </div>

            <div class="col-md-1 col-sm-12 col-xs-12">
              <p></p>
              <q-btn
                class="q-mt-sm full-width"
                color="positive"
                label="Criar"
                no-caps
                icon="add"
                @click.prevent="cadastrarModulo"
              />
            </div>
          </div>
        </q-form>
      </q-card-section>
    </q-card>

    <q-card class="q-mt-md">
      <div class="q-pa-md">
        <q-table
          title="Modulos Cadastrados"
          :rows="listaModulos"
          :columns="columns"
          row-key="name"
          class="tabela-tamanho-fixo"
          :rows-per-page-options="[0]"
          dense
        >
          <template v-slot:body="props">
            <q-tr :props="props">
              <q-td class="text-left" key="nome" :props="props">{{
                props.row.nome
              }}</q-td>
              <q-td class="text-left" key="nome" :props="props">{{
                props.row.moduloId
              }}</q-td>
              <q-td class="text-right">
                <q-btn
                  flat
                  text-color="red"
                  round
                  icon="delete"
                  @click="confirmarRemover(props.row.moduloId)"
                />
              </q-td>
            </q-tr>
          </template>
        </q-table>
      </div>
    </q-card>

    <DialogConfirmDesign
      :exibir="modalRemover"
      mensagem="Tem certeza que deseja remover esse Modulo?"
      @resultado="handleRemoverConfirmacao"
    />
  </q-page>
</template>

<script>
import { ref, onMounted } from "vue";
import { useStore } from "vuex";
import { useQuasar } from "quasar";
import DialogConfirmDesign from "../../../components/DialogConfirmDesign.vue";
import PageHeader from "../../../components/PageHeader.vue";

const columns = [
  {
    name: "nome",
    align: "left",
    label: "NOME MODULO",
    field: "NOME MODULO",
    sortable: true,
  },
  {
    name: "id",
    align: "left",
    label: "ID MODULO",
    field: (row) => row.moduloId,
    sortable: true,
  },
];

export default {
  name: "DetalheCliente",
  components: { DialogConfirmDesign, PageHeader },
  setup() {
    const nomeModulo = ref("");
    const idModulo = ref("");
    const $q = useQuasar();
    const store = useStore();
    const listaModulos = ref([]);
    const modalRemover = ref(false);
    const moduloIdParaRemover = ref(null);

    const cadastrarModulo = async () => {
      if (idModulo.value.length != 3 || idModulo.value == "") {
        $q.notify({
          message: "O id precisa ter exatos 3 caracteres",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        return;
      }
      try {
        await store.dispatch("office/cadastrarModulo", {
          nome: nomeModulo.value,
          moduloId: idModulo.value.toLowerCase(),
        });

        $q.notify({
          message: "Modulo Cadastrado!",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        listarModulos();
      } catch (error) {
        $q.notify({
          message: "Erro a o cadastrar modulo",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const listarModulos = async () => {
      try {
        let response = await store.dispatch("office/ListarModulos");

        listaModulos.value = response.data.resultado.dados;
      } catch (error) {
        $q.notify({
          message: "Listar modulos",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    onMounted(listarModulos);

    const confirmarRemover = (moduloId) => {
      moduloIdParaRemover.value = moduloId;
      modalRemover.value = true;
    };

    const handleRemoverConfirmacao = async (confirmado) => {
      modalRemover.value = false;
      if (confirmado) {
        await removerModulo(moduloIdParaRemover.value);
      }
      moduloIdParaRemover.value = null;
    };

    const removerModulo = async (moduloId) => {
      try {
        await store.dispatch("office/removerModulo", {
          moduloId,
        });

        $q.notify({
          message: "Modulo removido com sucesso!",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        listarModulos();
      } catch (error) {
        $q.notify({
          message: "Erro ao tentar  remover modulo",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    return {
      columns,
      removerModulo,
      cadastrarModulo,
      nomeModulo,
      listarModulos,
      listaModulos,
      idModulo,
      modalRemover,
      confirmarRemover,
      handleRemoverConfirmacao,
    };
  },
};
</script>
